import * as Tabs from '@radix-ui/react-tabs';
import { Navigate, useNavigate, useParams } from 'react-router';
import PANEL_CAPABILITIES from '../../shared/panelCapabilities';
import ConsultantTab from './consultant/ConsultantTab';
import AvaTab from './ava/AvaTab';
import ModelSettingsPanel from './consultant/ModelSettingsPanel';
import SubscriptionStatusWidget from './SubscriptionStatusWidget';

const SECTIONS = [
  { value: 'consultant', label: 'مشاور مشتری', capability: 'ai.consultant' },
  { value: 'ava', label: 'آوا', capability: 'ai.ava' },
  { value: 'models', label: 'تنظیمات مدل‌ها', capability: 'ai.models' },
];

export default function AiTab({ role }) {
  const { tab, sub } = useParams();
  const navigate = useNavigate();
  const visibleSections = SECTIONS.filter(({ capability }) => (
    PANEL_CAPABILITIES.canAccessPanelSection(role, capability)
  ));
  const visibleValues = new Set(visibleSections.map(({ value }) => value));
  if (visibleSections.length === 0) {
    return <div className="admin-subgroup" role="status">شما به هیچ بخش هوش مصنوعی دسترسی ندارید.</div>;
  }
  const defaultSection = visibleSections[0].value;
  const activeSection = tab === 'ai' && visibleValues.has(sub) ? sub : defaultSection;
  if (tab === 'ai' && sub !== activeSection) return <Navigate to={`/admin/ai/${activeSection}`} replace />;

  return (
    <div className="admin-subgroup" dir="rtl">
      <Tabs.Root value={activeSection} onValueChange={(value) => navigate(`/admin/ai/${value}`)} dir="rtl">
        <Tabs.List className="admin-subnav" aria-label="بخش‌های هوش مصنوعی">
          {visibleSections.map(({ value, label }) => (
            <Tabs.Trigger className="admin-subtab" value={value} key={value}>{label}</Tabs.Trigger>
          ))}
        </Tabs.List>
        {visibleValues.has('consultant') && (
          <Tabs.Content value="consultant" forceMount className="admin-subtab-content inspection-tab-content">
            <ConsultantTab />
          </Tabs.Content>
        )}
        {visibleValues.has('ava') && (
          <Tabs.Content value="ava" forceMount className="admin-subtab-content ava-tab-content">
            <AvaTab role={role} />
          </Tabs.Content>
        )}
        {visibleValues.has('models') && (
          <Tabs.Content value="models" className="admin-subtab-content">
            <SubscriptionStatusWidget />
            <ModelSettingsPanel />
          </Tabs.Content>
        )}
      </Tabs.Root>
    </div>
  );
}
